import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=d792dde6&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=ts"
export * from "./OrderModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=d792dde6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d792dde6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d792dde6')) {
      api.createRecord('d792dde6', component.options)
    } else {
      api.reload('d792dde6', component.options)
    }
    module.hot.accept("./OrderModal.vue?vue&type=template&id=d792dde6&scoped=true", function () {
      api.rerender('d792dde6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderModal.vue"
export default component.exports